import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/td-modal';

class ModalWithToggleButton extends Component {
  state = {
    isModalOpen: false
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.shouldCloseModal && this.props.shouldCloseModal) {
      this.closeModal();
    }
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });

    const onClose = this.props.onClose;
    if (onClose) {
      onClose();
    }
  };

  render() {
    const {
      title,
      buttonProps: { text, className },
      children
    } = this.props;

    return (
      <div>
        <button onClick={this.openModal} className={className}>
          {text}
        </button>
        <Modal isOpen={this.state.isModalOpen} notifyOfClose={this.closeModal} title={title}>
          {children}
        </Modal>
      </div>
    );
  }
}

ModalWithToggleButton.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  buttonProps: PropTypes.object,
  children: PropTypes.node.isRequired,
  shouldCloseModal: PropTypes.bool.isRequired
};

ModalWithToggleButton.defaultProps = {
  title: 'Modal',
  buttonProps: {
    className: 'button',
    text: 'Open Modal'
  },
  shouldCloseModal: false
};

export default ModalWithToggleButton;
